/**
 * Designed by OnHOW YouTube Channel - Anas El Medlaoui
 */

const onhowStyles = `
  .onhow-accordion .icon-caret {
    transform: scale(1.25); 
  }
  
  .onhow-accordion .accordion__title {
    font-size: calc(var(--font-heading-scale) * 1.13em); 
  }
  
  .onhow-accordion details[open] .accordion__content {
    animation: slowReveal 400ms ease-in-out; 
  }
  
  @keyframes slowReveal {
    0% { opacity: 0; transform: translateY(-8px); }
    100% { opacity: 1; transform: translateY(0); }
  }
`;

function addStyles(stylesText) {
  const styleElement = document.createElement('style');
  styleElement.textContent = stylesText;
  document.head.appendChild(styleElement);
}

class OnhowDescriptionAccordion {
  constructor() {
    this.descriptionContainer = document.querySelector('.product__description.rte');
    if (!this.descriptionContainer) return;
    
    addStyles(onhowStyles);
    
    this.init();
  }

  init() {
    this.originalContent = this.descriptionContainer.innerHTML;
    
    const h3Elements = this.descriptionContainer.querySelectorAll('h3');
    if (h3Elements.length > 0) {
      this.createAccordion(h3Elements);
    }
  }

  createAccordion(h3Elements) {

    const accordionContainer = document.createElement('div');
    accordionContainer.className = 'onhow-accordion product__accordion accordion quick-add-hidden';

    h3Elements.forEach((h3Element, index) => {
  
      let contentElements = [];
      let currentElement = h3Element.nextElementSibling;
      
      while (currentElement && currentElement.tagName !== 'H3') {
        contentElements.push(currentElement.cloneNode(true));
        currentElement = currentElement.nextElementSibling;
      }
      
      const details = document.createElement('details');
      details.id = `Details-onhow-${index}`;
      if (index === 0) details.setAttribute('open', '');
      
      const summary = document.createElement('summary');
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');
      summary.setAttribute('aria-controls', `ProductAccordion-onhow-${index}`);
      
      const summaryTitle = document.createElement('div');
      summaryTitle.className = 'summary__title';
      
      const heading = document.createElement('h2');
      heading.className = 'h4 accordion__title';
      heading.textContent = h3Element.textContent;
      
      const iconContainer = document.createElement('span');
      iconContainer.innerHTML = `<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-caret" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
      </svg>`;
      
      const content = document.createElement('div');
      content.className = 'accordion__content rte';
      content.id = `ProductAccordion-onhow-${index}`;
      
      contentElements.forEach(element => {
        content.appendChild(element);
      });
      
      summaryTitle.appendChild(heading);
      summary.appendChild(summaryTitle);
      summary.appendChild(iconContainer);
      details.appendChild(summary);
      details.appendChild(content);
      accordionContainer.appendChild(details);
    });
    
    this.descriptionContainer.innerHTML = '';
    this.descriptionContainer.appendChild(accordionContainer);
    
    this.initializeAccordion();
  }

  initializeAccordion() {
    const detailsElements = this.descriptionContainer.querySelectorAll('details');
    
    detailsElements.forEach(details => {
      const summary = details.querySelector('summary');
      summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !details.hasAttribute('open'));
      });
      
      details.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;
        
        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', 'false');
        summaryElement.focus();
      });
    });
  }
  
  restoreOriginalDescription() {
    if (this.originalContent) {
      this.descriptionContainer.innerHTML = this.originalContent;
    }
  }
}
(function() {
  function initAccordion() {
    if (document.querySelector('.product__description.rte')) {
      new OnhowDescriptionAccordion();
    } else if (document.readyState !== 'complete') {
      setTimeout(initAccordion, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }
})();